import { Suspense } from 'react';
import { Divider } from '@mui/material';
import { Routes, Route, Outlet, Navigate } from 'react-router';
import { withAppInsights } from 'app/app-insights';
import { AssetProvider, ParametersProvider } from 'context';
import ParameterView from './parameter-view';
import Details from './parameter-details-pane';

function ParametersPage() {
  return (
    <main>
      <Routes>
        <Route
          path="parameters"
          element={
            <Suspense fallback={null}>
              <AssetProvider>
                <ParametersProvider>
                  <Divider orientation="vertical" flexItem />
                  <ParameterView />
                  <Outlet />
                </ParametersProvider>
              </AssetProvider>
            </Suspense>
          }
        >
          <Route
            path=":parameterId"
            element={
              <Suspense fallback={null}>
                <Divider orientation="vertical" flexItem />
                <Details />
              </Suspense>
            }
          />
          <Route path="*" element={<Navigate to="/error" replace />} />
        </Route>
        <Route
          path="asset/:assetId/parameters"
          element={
            <Suspense fallback={null}>
              <AssetProvider>
                <ParametersProvider>
                  <Divider orientation="vertical" flexItem />
                  <ParameterView />
                  <Outlet />
                </ParametersProvider>
              </AssetProvider>
            </Suspense>
          }
        >
          <Route
            path=":parameterId"
            element={
              <Suspense fallback={null}>
                <Divider orientation="vertical" flexItem />
                <Details />
              </Suspense>
            }
          />
          <Route path="*" element={<Navigate to="/error" replace />} />
        </Route>
        <Route path="*" element={<Navigate to="/error" replace />} />
      </Routes>
    </main>
  );
}

export default withAppInsights(ParametersPage, 'ParametersPage');
